<div class="row">
  <div class="mt-2 auction-filter col-lg-3">
    <div class="d-flex justify-content-lg-between justify-content-center align-items-center filter-heading">
      <h4>Filter by</h4>
      <button class="btn text-red d-none d-lg-flex" (click)="Clear()">Clear</button>
      <button class="btn text-white d-lg-none shadow-none" (click)="OpenFilters()"><i class="fa fa-angle-down font-lg"></i></button>
    </div>
    <ul class="p-0 d-none d-lg-block filters" [ngClass]="{ 'd-block': IsFilterOpen }">
      <li>
        <auction-search-filter-item-text [model]="filters.keyword" (updated)="Updated()" (doEdit)="EditFacet('keyword')" [modalMode]="false"></auction-search-filter-item-text>
      </li>
      <li>
        <auction-search-filter-item-choices [model]="filters.category" (updated)="Updated()" (doEdit)="EditFacet('category')" [modalMode]="false"></auction-search-filter-item-choices>
      </li>
      <li>
        <auction-search-filter-item-text [model]="filters.lotNumber" (updated)="Updated()" (doEdit)="EditFacet('lotnumber')" [modalMode]="false"></auction-search-filter-item-text>
      </li>
      <li>
        <auction-search-filter-item-range [model]="filters.price" (updated)="Updated()" (doEdit)="EditFacet('price')" [modalMode]="false"></auction-search-filter-item-range>
      </li>
      <li>
        <auction-search-filter-item-choices [model]="filters.vintage" (updated)="Updated()" (doEdit)="EditFacet('vintage')" [modalMode]="false"></auction-search-filter-item-choices>
      </li>
      <li>
        <auction-search-filter-item-choices [model]="filters.country" (updated)="Updated()" (doEdit)="EditFacet('country')" [modalMode]="false"></auction-search-filter-item-choices>
      </li>
      <li>
        <auction-search-filter-item-choices [model]="filters.region" (updated)="RegionUpdated()" (doEdit)="EditFacet('region')" [modalMode]="false"></auction-search-filter-item-choices>
      </li>
      <li>
        <auction-search-filter-item-choices [model]="filters.winery" (updated)="WineryUpdated()" (doEdit)="EditFacet('winery')" [modalMode]="false"></auction-search-filter-item-choices>
      </li>
      <li>
        <auction-search-filter-item-choices [model]="filters.variety" (updated)="Updated()" (doEdit)="EditFacet('variety')" [modalMode]="false"></auction-search-filter-item-choices>
      </li>
      <li>
        <auction-search-filter-item-choices [model]="filters.unitOfMeasure" (updated)="Updated()" (doEdit)="EditFacet('unitofmeasure')" [modalMode]="false"></auction-search-filter-item-choices>
      </li>
      <li>
        <auction-search-filter-item-choices [model]="filters.excludeAttribute" (updated)="Updated()" (doEdit)="EditFacet('exclude')" [modalMode]="false"></auction-search-filter-item-choices>
      </li>
      <li>
        <auction-search-saved-filters [model]="customFilters" (applyFilter)="ApplyCustomFilter($event)" (deleteFilter)="DeleteCustomFilter($event)"></auction-search-saved-filters>
      </li>
    </ul>
    <button class="btn btn-primary btn-red mb-2 w-100 d-none d-lg-block" [disabled]="!stateService.userModel" (click)="CreateCustomFilter()" [ngClass]="{ 'd-block': IsFilterOpen }">Save Custom Filter</button>
  </div>


  <div class="col-lg-9">
    <!-- <div class="alert alert-warning text-center mt-2" *ngIf="NoFilterEditing()" style="min-height: 20vh;">
      <div class="mb-3 mt-4">
        <i class="fa fa-2x fa-info-circle"></i>
      </div>
      <h5>Please select a filter facet on the left to manage your selections.</h5>
    </div> -->
    <div class="p-3 mt-2 save-filter">
      <h2 class="save-filter-heading mb-3" *ngIf="!AreFiltersDefined()">How to get started</h2>
      <h2 class="save-filter-heading mb-4" *ngIf="AreFiltersDefined()">Currently selected filters</h2>
      <p class="text-opacity-7" *ngIf="!AreFiltersDefined()">Custom filters are a great way to speed up your search for wine. Follow these 3 simple steps to get started .</p>
      <ol class="pl-3 text-opacity-7" *ngIf="!AreFiltersDefined()">
        <li>Select filters from the left hand side for this particolar filter </li>
        <li>Save your filter using the “save” button at the top of the page and givie it a name </li>
        <li>Apply your filter by simply clicking on it on the auction search page</li>
      </ol>

      <!-- <div class="alert alert-secondary text-center mt-2" *ngIf="!AreFiltersDefined()" style="min-height: 20vh;"> -->

      <div class="mb-2" *ngIf="filters.keyword.value">
        <h5 class="d-inline-block mr-2">Keyword</h5>
        <span class="text-danger">{{filters.keyword.value}}</span>
      </div>

      <div class="mb-2" *ngIf="filters.category.values.length">
        <h5 class="d-inline-block mr-2">Categories</h5>
        <div class="d-inline-block">
          <span class="badge-danger mr-2 p-1" *ngFor="let item of filters.category.values">{{item.label}}</span>
        </div>
      </div>

      <div class="mb-2" *ngIf="filters.lotNumber.value">
        <h5 class="d-inline-block mr-2">Lot Numbers</h5>
        <span class="text-danger">{{filters.lotNumber.value}}</span>
      </div>

      <div class="mb-2" *ngIf="filters.price.value">
        <h5 class="d-inline-block mr-2">Price range</h5>
        <span class="text-danger">From {{filters.price.value}}</span>
      </div>

      <div class="mb-2" *ngIf="filters.vintage.values.length">
        <h5 class="d-inline-block mr-2">Vintages</h5>
        <div class="d-inline-block">
          <span class="badge-danger mr-2 p-1" *ngFor="let item of filters.vintage.values">{{item.label}}</span>
        </div>
      </div>

      <div class="mb-2" *ngIf="filters.country.values.length">
        <h5 class="d-inline-block mr-2">Countries</h5>
        <div class="d-inline-block">
          <span class="badge-danger mr-2 p-1" *ngFor="let item of filters.country.values">{{item.label}}</span>
        </div>
      </div>

      <div class="mb-2" *ngIf="filters.region.values.length">
        <h5 class="d-inline-block mr-2">Regions</h5>
        <div class="d-inline-block">
          <span class="badge-danger mr-2 p-1" *ngFor="let item of filters.region.values">{{item.label}}</span>
        </div>
      </div>

      <div class="mb-2" *ngIf="filters.winery.values.length">
        <h5 class="d-inline-block mr-2">Wineries</h5>
        <div class="d-inline-block">
          <span class="badge-danger mr-2 p-1" *ngFor="let item of filters.winery.values">{{item.label}}</span>
        </div>
      </div>

      <div class="mb-2" *ngIf="filters.variety.values.length">
        <h5 class="d-inline-block mr-2">Varieties</h5>
        <div class="d-inline-block">
          <span class="badge-danger mr-2 p-1" *ngFor="let item of filters.variety.values">{{item.label}}</span>
        </div>
      </div>

      <div class="mb-2" *ngIf="filters.unitOfMeasure.values.length">
        <h5 class="d-inline-block mr-2">Sizes</h5>
        <div class="d-inline-block">
          <span class="badge-danger mr-2 p-1" *ngFor="let item of filters.unitOfMeasure.values">{{item.label}}</span>
        </div>
      </div>

      <div class="mb-2" *ngIf="filters.excludeAttribute.values.length">
        <h5 class="d-inline-block mr-2">Excluded conditions</h5>
        <div class="d-inline-block">
          <span class="badge-danger mr-2 p-1" *ngFor="let item of filters.excludeAttribute.values">{{item.label}}</span>
        </div>
      </div>

      <div *ngIf="AreFiltersDefined()" class="font-sm mt-4">
        <p>To remove filters simply click on the ‘x’ in the filter list on the left hand side. </p>
        <p>You can continue to add additional filters.</p>
        <p>Save your filter using the “save” button at the top of the page and give it a name. </p>
      </div>

    </div>
    <div class="custom-filters">
      <search-filter-item-text class="d-block mt-2 filter-custom-item" *ngIf="editKeyword" [model]="filters.keyword" (apply)="ApplyFacetChange(filters.keyword, $event, 'keyword')" [modalMode]="false" (close)="ToggleFacetFlag('keyword',false)"></search-filter-item-text>
      <search-filter-item-choices class="d-block mt-2 filter-custom-item" *ngIf="editCategory" [model]="filters.category" (apply)="ApplyFacetChange(filters.category, $event, 'category')" [modalMode]="false" (close)="ToggleFacetFlag('category',false)"></search-filter-item-choices>
      <search-filter-item-text class="d-block mt-2 filter-custom-item" *ngIf="editLotNumber" [model]="filters.lotNumber" (apply)="ApplyFacetChange(filters.lotNumber, $event, 'lotnumber')" [modalMode]="false" (close)="ToggleFacetFlag('lotnumber',false)"></search-filter-item-text>
      <search-filter-item-range class="d-block mt-2 filter-custom-item" *ngIf="editPrice" [model]="filters.price" (apply)="ApplyFacetChange(filters.price, $event, 'price')" [modalMode]="false" (close)="ToggleFacetFlag('price',false)"></search-filter-item-range>
      <search-filter-item-choices class="d-block mt-2 filter-custom-item" *ngIf="editVintage" [model]="filters.vintage" (apply)="ApplyFacetChange(filters.vintage, $event, 'vintage')" [modalMode]="false" (close)="ToggleFacetFlag('vintage',false)"></search-filter-item-choices>
      <search-filter-item-choices class="d-block mt-2 filter-custom-item" *ngIf="editCountry" [model]="filters.country" (apply)="ApplyFacetChange(filters.country, $event, 'country')" [modalMode]="false" (close)="ToggleFacetFlag('country',false)"></search-filter-item-choices>
      <search-filter-item-choices class="d-block mt-2 filter-custom-item" *ngIf="editRegion" [model]="filters.region" (apply)="ApplyFacetChange(filters.region, $event, 'region')" [modalMode]="false" (close)="ToggleFacetFlag('region',false)"></search-filter-item-choices>
      <search-filter-item-choices class="d-block mt-2 filter-custom-item" *ngIf="editWinery" [model]="filters.winery" (apply)="ApplyFacetChange(filters.winery, $event, 'winery')" [modalMode]="false" (close)="ToggleFacetFlag('winery',false)"></search-filter-item-choices>
      <search-filter-item-choices class="d-block mt-2 filter-custom-item" *ngIf="editVariety" [model]="filters.variety" (apply)="ApplyFacetChange(filters.variety, $event, 'variety')" [modalMode]="false" (close)="ToggleFacetFlag('variety',false)"></search-filter-item-choices>
      <search-filter-item-choices class="d-block mt-2 filter-custom-item" *ngIf="editUnitOfMeasure" [model]="filters.unitOfMeasure" (apply)="ApplyFacetChange(filters.unitOfMeasure, $event, 'unitofmeasure')" [modalMode]="false" (close)="ToggleFacetFlag('unitofmeasure',false)"></search-filter-item-choices>
      <search-filter-item-choices class="d-block mt-2 filter-custom-item" *ngIf="editExclude" [model]="filters.excludeAttribute" (apply)="ApplyFacetChange(filters.excludeAttribute, $event, 'exclude')" [modalMode]="false" (close)="ToggleFacetFlag('exclude',false)"></search-filter-item-choices>
    </div>
  </div>
</div>
